import { FC } from 'react';
import './styles.scss';

interface Props {
  text: string;
}

const TagSuccess: FC<Props> = ({ text }) => {
  return (
    <span className={'TagSuccess'}>
      {text}
    </span>
  );
}

export default TagSuccess;